import { render } from "./hotel_images.vue?vue&type=template&id=5d237e64"
import script from "./hotel_images.vue?vue&type=script&lang=js"
export * from "./hotel_images.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__